import { Link } from 'react-router-dom'
import { Btn } from '../../../../../AbstractElements'
import { AddToCart, AddToWishList, BuyNow } from '../../../../../utils/Constant'

const ProductButtons = () => {
  return (
    <div className="m-t-15 btn-showcase">
    <Link to={`${process.env.PUBLIC_URL}/ecommerce/cart`} >
      <Btn color="primary">
        <i className="fa fa-shopping-basket me-1" />
        {AddToCart}
      </Btn>
    </Link>
    <Link to={`${process.env.PUBLIC_URL}/ecommerce/checkout`} >
      <Btn color="success">
        <i className="fa fa-shopping-cart me-1" />
        {BuyNow}
      </Btn>
    </Link>
    <Link to={`${process.env.PUBLIC_URL}/ecommerce/wishlist`} >
      <Btn color="secondary">
        <i className="fa fa-heart me-1" />
        {AddToWishList}
      </Btn>
    </Link>
    </div>
  )
}

export default ProductButtons